import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { GlobalEmittersService } from './global-emitters.service';

@Injectable({
    providedIn: 'root',
})
export class RouteServiceService implements CanActivate {
    enableRoute: boolean = true;
    constructor(private router: Router) {}
    canActivate(): boolean {
        if (this.enableRoute) {
            return true;
        } else {
            this.router.navigate(['/']);
        }
    }
}
